import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface FormSectionTitleProps {
  children?: ReactNode;
  margin?: string | number;
}

export const FormSectionTitle = ({
    children,
    margin = "1rem 0 .5rem 0",
}: FormSectionTitleProps) => (
    <Typography variant="h6" sx={{ margin }}>
        {children}
    </Typography>
);
